/*! Lazy init for predictive search to improve INP */
(function(){
  function loadScriptOnce(src, cb){
    if(document.querySelector('script[data-lazy-src="'+src+'"]')){ cb && cb(); return; }
    var s=document.createElement('script'); s.src=src; s.defer=true; s.dataset.lazySrc=src;
    s.onload=function(){ cb && cb(); }; document.head.appendChild(s);
  }
  // Predictive search: load on first focus/typing in search input
  document.addEventListener('focusin', function(e){
    var input = e.target.closest('input[type="search"], predictive-search input');
    if(!input) return;
    var url = '{{ "predictive-search.aio.min.js" | asset_url }}';
    loadScriptOnce(url);
  }, true);

})();